"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentImportProfile = void 0;
exports.contentImportProfile = {
    name: 'contentImport',
    methods: ['resolve', 'resolveAndSave'],
};
//# sourceMappingURL=profile.js.map